export class CSVDocument {
  bezeichnung : string;
  name : string;
  anhangDatei : File;

  constructor(bezeichning: string, name: string, anhangDatei: File) {
    this.bezeichnung = bezeichning;
    this.name = name;
    this.anhangDatei = anhangDatei;
  }
}
